import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import Dropdown from '../../../../components/Dropdown';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import baseStyles from './css/BloodPressure.module.css';
import styles from './css/DietConsultWeekly.module.css';
import { Apple, Send } from 'lucide-react';

const DietConsultWeekly = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    // Measurements states
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [bmi, setBmi] = useState('');
    
    // Goals and adherence states
    const [goals, setGoals] = useState('');
    const [dietAdherence, setDietAdherence] = useState('');
    
    // Other states
    const [clinicalNotes, setClinicalNotes] = useState('');

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                diet_consult_weekly: {
                    weight,
                    height,
                    bmi,
                    goals,
                    dietAdherence,
                    clinicalNotes,
                },
            },
        });
    };

    useEffect(() => {
        document.body.classList.add(styles.hideSidebar);
        return () => {
            document.body.classList.remove(styles.hideSidebar);
        };
    }, []);

    return (
        <div className={styles.bloodPressureContainer}>
            <Navbar />

            <main className={styles.mainContent}>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.headerIcon} aria-hidden="true">
                            <Apple />
                        </div>
                        <h1 className={styles.title}>Diet Consult (Weekly)</h1>
                    </div>

                    <div className={styles.patientCard}>
                        <div className={styles.avatar} aria-hidden="true">{initials}</div>
                        <div className={styles.patientText}>
                            <div className={styles.patientName}>{patientName}</div>
                            <div className={styles.patientMetaRow}>
                                <span className={styles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={styles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>MEASUREMENTS</div>
                        <div className={styles.readingsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Weight</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={weight}
                                        onChange={(e) => setWeight(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder='—'
                                    />
                                    <span className={styles.unit}>kg</span>
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Height</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={height}
                                        onChange={(e) => setHeight(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder='—'
                                    />
                                    <span className={styles.unit}>cm</span>
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>BMI (auto-calculated)</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={bmi}
                                        onChange={(e) => setBmi(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder='—'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>GOALS AND ADHERANCE</div>
                        <div className={styles.readingsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Goals</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="text"
                                        value={goals}
                                        onChange={(e) => setGoals(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder='e.g., lose 5kg in three months'
                                    />
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Diet Adherance</label>
                                <div className={styles.inputGroup}>
                                    <Dropdown
                                        name="dietAdherence"
                                        value={dietAdherence}
                                        onChange={setDietAdherence}
                                        options={['Excellent', 'Good', 'Fair', 'Poor']}
                                        placeholder="Select..."
                                        className={styles.readingInput}
                                        alignLeft
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={styles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={styles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={styles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default DietConsultWeekly;